const comments = [
  {
    name: '影迷小张',
    date: '2026-07-29',
    text: '91免费视频网站真的太良心了！资源丰富，画质高清，而且完全免费不用注册，每天下班回家都要刷几部国产剧情片放松一下。推荐给身边好多朋友了！',
    likes: 128,
  },
  {
    name: '剧荒拯救者',
    date: '2026-07-28',
    text: '之前一直在找靠谱的国产免费视频网站，试了好几个都不太行，直到发现了91免费视频网站。91传媒视频在线的质量确实高，更新也快，基本想看的都能找到。',
    likes: 96,
  },
  {
    name: '深夜电影党',
    date: '2026-07-28',
    text: '最大的感受就是流畅不缓冲，这点太重要了！看91国产免费视频的时候完全不用担心卡顿，而且手机端体验也很好，晚上躺床上刷剧超舒服。',
    likes: 75,
  },
  {
    name: '老影迷老王',
    date: '2026-07-27',
    text: '作为一个看了几十年国产电影的老影迷，91免费视频网站上的91年国产影片视频专区让我特别感动，很多经典老片在这里都能找到高清修复版，满满都是回忆。',
    likes: 62,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            听听91免费视频网站的忠实观众们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 rounded-xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.text}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line w-4 h-4 flex items-center justify-center"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}